export default __webpack_public_path__ + "static/media/EUR.ab85efd2.svg";